import { Component, OnInit, OnDestroy, Renderer2, Input, ViewChild, ElementRef } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem, FileUpload } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { AdditionalData } from './AdditionalData';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-staffrecruitmentonline',
    templateUrl: './staffrecruitmentonline.component.html',
    styleUrls: ['./staffrecruitmentonline.component.scss'],
    providers: [MessageService, ConfirmationService]
})
export class StaffrecruitmentonlineComponent implements OnInit {
    msgs: Message[] = [];
    info: Message[] = [];
    accept: boolean = false;
    donotaccept: boolean = false;
    copyaddress: boolean = false;
    //msgsuccess: Message[] = [];
    generalInformationForm: FormGroup;
    minDateOfBirth: Date;
    maxDateOfBirth: Date;
    dateOfBirth: Date;
    maxDateOfBirthYear: number;
    minDateOfBirthYear: number;
    dataList: any;
    boardName: any;
    cdt: any;
    fm: any;
    tm: any;
    dbm: any;
    dby: any;
    displayForm: boolean = false;
    public genderList = [];
    public genericList = [];
    public categoryList = [];
    public postcategoryList = [];
    public departList = [];
    public distList = [];
    public phycalHList = [];
    public postlist = [];
    public subjectSPLList = [];
    public boardList = [];
    public examList = [];
    public yearList = [];
    public emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    public expList = [];
    public acaList = [];
    public staffDetailsInfo = [];
    public typeofEmplpyment = [];
    public nationalitylist = [];
    public religionlist = [];
    public maritalstatuslist = [];
    scrollHeight: string = '400px';
    distName: any;
    academicdetailList: any;
    acaDetailsInfo: {
        academicyr: any,
        edudetail: any,
        exampass: any,
        id: any,
        parent_id: any,
        marks: any,
        subjectstudied: any,
        otherinfo: any,
        division: any,
        certificate: any,
        certificatename: any
    }[];
    expDetailsInfo: {
        id: any,
        parent_id: any,
        //fromdate: any,
        //todate: any,
        instituteName: any,
        yearcount: any,
        typeofemployee: any,
        //monthcount: any,
        designation: any,
        //institutetype:any,
        payscale: any,
        expcertificate: any,
        remarks: any,
        //presentemployer:any
    }[];
    rowData: any;
    processbar: boolean = false;
    user_id: any;
    designationId: any;
    postcategoryid: any;
    departmentId: any;
    showdeleteBtn: boolean = false;
    advid: any;
    advName: any;
    showdept: boolean = false;
    public typeofInstList = [];
    fileToUpload: File = null;
    uploadUrl: string;
    uploadedFiles: any[] = [];
    input = new FormData();
    advt: any;
    public advtList = [];
    forpayment: boolean = false;
    paymentmsg: any;
    disablesubmit: boolean = false;
    shownocCertificate: boolean = false;
    showcastecertificate: boolean = false;
    showphcertificate: boolean = false;
    showpdfdialog: boolean = false;
    pdflink: any;
    previouslyapplied: boolean = false
    showbankdetails: boolean = false;
    displayConfirmation = false;
    confirmmsg: any;
    userdtetails: any;
    chkusertyp: boolean = false;
    showprintForm: boolean = false;
    showprintFormChallan: boolean = false;
    certlist: any;
    photolink: any;
    signlink: any;
    doblink: any;
    castelink: any;
    phlink: any;
    lpclink: any;
    presentemployerlink: any;
    duplicatepdflink: any;
    duplicatechallanlink: any;
    showformlink: boolean = false;
    certlinks = [];
    show: boolean;
    hideoldbankdetails: boolean = false;
    departmentFlag: boolean = false;
    checkPostFlag: boolean = false;

    constructor(private registrationService: RegistrationService, private router: Router, private confirmationService: ConfirmationService) { }

    @Input() additionaldata: AdditionalData;
    @ViewChild('form') form: ElementRef;

    ngOnInit() {
        //this.advName = localStorage.getItem('advName');
        this.displayForm = true;
        this.advt = 0;
        this.user_id = localStorage.getItem('member-id');
        this.info = [];
        this.info.push({ severity: 'info', summary: 'Please Note :' });
        //this.info.push({ severity: 'info', detail: '1. Request for change of mailing address/ category/ Discipline etc once declared in the online application form will not be allowed / entertain for any Editing.' });
        this.info.push({ severity: 'info', detail: '1. All fields marked with red dots are mandatory.' });
        this.info.push({ severity: 'info', detail: '2. Mobile Number and Password will be used as your Loginid and password.' });
        this.info.push({ severity: 'info', detail: '3. Photo and Signature maximum size 50kb, supported formats : jpeg, jpg, png' });
        this.info.push({ severity: 'info', detail: '4. All other upload documents maximum size 200kb, supported formats : jpeg, jpg, png, pdf' });


        this.typeofInstList = [
            {
                'id': 'College',
                'name': 'College'
            },
            {
                'id': 'University',
                'name': 'University'
            },
            {
                'id': 'Institute',
                'name': 'Institute'
            }
        ]
        this.maritalstatuslist = [
            {
                'id': 'Single',
                'name': 'Single'
            }, {
                'id': 'Married',
                'name': 'Married'
            }
        ]
        this.genderList = [
            {
                'id': 'Male',
                'name': 'Male'
            }, {
                'id': 'Female',
                'name': 'Female'
            }, {
                'id': 'Third Gender',
                'name': 'Third Gender'
            }
        ];

        this.genericList = [
            {
                'id': 'NO',
                'name': 'NO'
            }, {
                'id': 'YES',
                'name': 'YES'
            }
        ];
        this.typeofEmplpyment = [
            {
                'id': 'PERMANENT',
                'name': 'PERMANENT'
            }, {
                'id': 'CONTRACTUAL',
                'name': 'CONTRACTUAL'
            }, {
                'id': 'GUEST LECTURER',
                'name': 'GUEST LECTURER'
            }
            , {
                'id': 'PART TIME',
                'name': 'PART TIME'
            }
        ];
        this.additionaldata = new AdditionalData;
        this.additionaldata.academicData = [
            {
                academicyr: 0,
                edudetail: 0,
                exampass: 0,
                id: '',
                parent_id: '',
                marks: '',
                subjectstudied: '',
                otherinfo: '',
                division: '',
                certificate: '',
                certificatename: ''
            }
        ];
        this.additionaldata.experienceData = [
            {
                id: '',
                parent_id: '',
                instituteName: '',
                yearcount: '',
                typeofemployee: 0,
                designation: '',
                payscale: '',
                expcertificate: '',
                remarks: '',
            }
        ];
        const TODAY = new Date();
        const MONTH = TODAY.getMonth();
        const YEAR = TODAY.getFullYear();

        this.maxDateOfBirthYear = YEAR;
        this.minDateOfBirthYear = YEAR - 60;

        this.minDateOfBirth = new Date();
        this.minDateOfBirth.setMonth(MONTH);
        this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);

        this.maxDateOfBirth = new Date();
        this.maxDateOfBirth.setMonth(MONTH);
        this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);

        this.dateOfBirth = this.maxDateOfBirth;
        this.processbar = true;
        this.registrationService.getAdvList().then(res => {
            this.dataList = res;
            if (this.dataList.status == 'success') {
                this.processbar = false;
                this.advtList = this.dataList.advmentlist;
            }
            else {
                this.processbar = false;
                alert(this.dataList.msg);
            }
        }, error => {
            this.processbar = false;
        });

        if (localStorage.getItem('userdtls')) {
            this.userdtetails = JSON.parse(localStorage.getItem('userdtls'));
            if (this.userdtetails.name) {
                this.showprintForm = true;
            }
            if (this.userdtetails.applicationNo) {
                this.showprintFormChallan = true;
            }
        }

        if (localStorage.getItem("utype")) {
            this.chkusertyp = true;
            this.getAllCommonList();
            //this.additionaldata = this.userdtetails;
        }

    }

    selectAdvtDone() {
        if (this.advt.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Advertisement' });
            return false;
        }
        this.displayForm = false;
        localStorage.setItem('advId', this.advt.id);
        localStorage.setItem('advName', this.advt.name);
        this.getAllCommonList();
    }

    getAllCommonList() {
        this.processbar = true;
        this.advid = localStorage.getItem('advId');
        if (this.advid == 4) {
            this.hideoldbankdetails = true;
        }
        else if (this.advid == 5) {
            this.hideoldbankdetails = false;
        }
        this.advName = localStorage.getItem('advName');
        this.registrationService.getCommonList(this.advid).then(res => {
            this.processbar = false;
            this.dataList = res;
            // console.log(this.dataList); // chk by Atanu
            if (this.dataList.chkdept == 1)
                this.departmentFlag = true;
            if (this.dataList.chkpost == 1)
                this.checkPostFlag = true;

            this.categoryList = this.dataList.categoryList;
            this.postcategoryList = this.dataList.postcategoryList;
            this.departList = this.dataList.departList;
            this.distList = this.dataList.distList;
            this.phycalHList = this.dataList.phycalHList;
            this.postlist = this.dataList.postlist;
            this.subjectSPLList = this.dataList.subjectSPLList;
            this.boardList = this.dataList.boardList;
            // this.boardList = this.dataList.boardList.name;
            this.examList = this.dataList.examList;
            this.yearList = this.dataList.yearList;
            this.nationalitylist = this.dataList.nationalitylist;
            this.religionlist = this.dataList.religionlist;
            this.yearList.push({ id: '-1', name: 'Select' });

            if (!localStorage.getItem('userdtls')) {
                this.additionaldata.designationId = 0;
                this.additionaldata.postcategoryid = 0;
                this.additionaldata.departmentId = 0;
                this.additionaldata.sex = 0;
                this.additionaldata.categoryId = 0;
                this.additionaldata.phid = 0;
                this.additionaldata.distId = 0;
                this.additionaldata.presentlyemployed = 0;
                this.additionaldata.nationalityid = 0;
                this.additionaldata.religionid = 0;
                this.additionaldata.maritalstatus = 0;
                this.additionaldata.disciplinary = 0;
                let acadata = [];
                acadata = this.additionaldata.academicData;
                for (let i = 0; i < this.examList.length; i++) {
                    this.acaAddRows();
                    acadata[i].exampass = this.examList[i].id; // by JD
                }
                this.additionaldata.academicData.splice(this.additionaldata.academicData.length - 1, 1);
            }
            //---------------------------------------------- set data on edit  mode ---------------------------------------//
            if (localStorage.getItem('userdtls')) {
                // console.log(localStorage.getItem('userdtls')); //by JD
                this.additionaldata = this.userdtetails;
                this.additionaldata.password = this.userdtetails.passworddtls;
                let d1, d2, d3;
                if (this.userdtetails.dob != null) {
                    d1 = new Date(Date.parse(this.userdtetails.dob));
                    this.additionaldata.dob = d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear();
                }

                if (this.userdtetails.phdthesissubmitdate != null) {
                    d3 = new Date(Date.parse(this.userdtetails.phdthesissubmitdate));
                    this.additionaldata.phdthesissubmitdate = d3.getDate() + '/' + (d3.getMonth() + 1) + '/' + d3.getFullYear();
                }

                if (this.userdtetails.oldbankdeaftno != null) {
                    this.previouslyapplied = true;
                    this.showbankdetails = true;
                    d2 = new Date(Date.parse(this.userdtetails.draftdate));
                    this.additionaldata.draftdate = d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear();
                }

                this.photolink = localStorage.getItem("photolink");
                this.signlink = localStorage.getItem("signlink");
                this.lpclink = localStorage.getItem("lpclink"); //add by jd
                this.doblink = localStorage.getItem("doblink");
                this.castelink = localStorage.getItem("castelink");
                this.phlink = localStorage.getItem("phlink");
                this.presentemployerlink = localStorage.getItem("presentemployerlink");
                if (localStorage.getItem("challanLink") != '-') {
                    this.showformlink = true;
                    this.duplicatechallanlink = localStorage.getItem("challanLink");
                }
                if (localStorage.getItem("admitsLink") != '-') {
                    this.showformlink = true;
                    this.duplicatepdflink = localStorage.getItem("admitsLink");
                }
                if (localStorage.getItem("acacertlinks")) {
                    this.certlinks = JSON.parse(localStorage.getItem("acacertlinks"));
                }

                let acadata = [];
                this.acaDetailsInfo = [];
                acadata = this.additionaldata.academicData.sort((a, b) => a.id - b.id);

                if (acadata.length != 0) {
                    for (let i = 0; i < acadata.length; i++) {
                        acadata[i].certificatename = this.certlinks[i].name;
                    }
                }

                if (acadata.length == 0) {
                    alert("Please Fill Up the Educational Qualification Details again.");
                    for (let i = 0; i < this.examList.length; i++) {
                        this.acaAddRows();
                        acadata[i].exampass = this.examList[i].id;
                        acadata[i].parent_id = this.additionaldata.id;
                    }
                }
                if (this.additionaldata.experienceData.length == 0) {
                    if (this.additionaldata.totalexperience != null || this.additionaldata.totalexperience != '') {
                        alert("Please Fill Up the Experience Details again.");
                    }
                    let expdata = [];
                    expdata = this.additionaldata.experienceData;
                    this.expAddRows();
                    for (let i = 0; i < expdata.length; i++) {
                        expdata[i].parent_id = this.additionaldata.id;
                    }
                }

                this.presentlemployer();
                this.showCastecert();
                this.showPhcert();
            }
        }, error => {
            this.processbar = false;
        });


    }


    _keyPress(event: any) {
        const pattern = /[0-9\+\-\.\ ]/;
        let inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    savestaffData() {
        if (this.additionaldata.designationId == null || this.additionaldata.designationId == 0) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
            return false;
        }
        if (this.advid == 4) {
            if (this.additionaldata.departmentId == null || this.additionaldata.departmentId == 0) {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
                return false;
            }
        }
        if (this.additionaldata.postcategoryid == null || this.additionaldata.postcategoryid == 0) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
            return false;
        }
        if (this.previouslyapplied) {
            if (this.additionaldata.oldbankdeaftno == null || this.additionaldata.oldbankdeaftno == '') {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Old Bank Draft no." });
                return false;
            }
            if (this.additionaldata.draftdate == null || this.additionaldata.draftdate == '') {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Draft Date" });
                return false;
            }
            if (this.additionaldata.drwanbank == null || this.additionaldata.drwanbank == '') {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Drawn on Bank" });
                return false;
            }
            if (this.additionaldata.drwanamount == null || this.additionaldata.drwanamount == '') {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Amount" });
                return false;
            }
        }

        if (this.additionaldata.name == null || this.additionaldata.name == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Applicant Name' });
            return false;
        }

        if (this.additionaldata.fathername == null || this.additionaldata.fathername == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Father's Name" });
            return false;
        }
        if (this.additionaldata.mothername == null || this.additionaldata.mothername == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Mother's Name" });
            return false;
        }

        if (this.additionaldata.email == null || this.additionaldata.email == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Email' });
            return false;
        }
        if (!this.validateEmail(this.additionaldata.email)) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Valid Email' });
            return false;
        }

        if (this.additionaldata.dob == null || this.additionaldata.dob == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter Date of Birth' });
            return false;
        }

        if (this.additionaldata.mobile == null || this.additionaldata.mobile == '' || this.additionaldata.mobile.length < 10) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Enter 10 Digit Mobile No.' });
            return false;
        }

        if (this.additionaldata.sex == null || this.additionaldata.sex == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Gender' });
            return false;
        }

        if (this.additionaldata.categoryId == null || this.additionaldata.categoryId == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Category' });
            return false;
        }
        if (this.additionaldata.phid == null || this.additionaldata.phid == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Physically Hanidcapped' });
            return false;
        }

        if (this.additionaldata.nationalityid == null || this.additionaldata.nationalityid == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Nationality' });
            return false;
        }
        if (this.additionaldata.religionid == null || this.additionaldata.religionid == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Religion' });
            return false;
        }
        if (this.additionaldata.maritalstatus == null || this.additionaldata.maritalstatus == '0') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Marital Status' });
            return false;
        }

        if (this.additionaldata.password == null || this.additionaldata.password == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Password" });
            return false;
        }

        if (this.additionaldata.mailingaddress == null || this.additionaldata.mailingaddress == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Mailing Address" });
            return false;
        }
        if (this.additionaldata.mailingpin == null || this.additionaldata.mailingpin == '' || this.additionaldata.mailingpin.length < 6) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Mailing Pin" });
            return false;
        }
        if (this.additionaldata.permanentaddress == null || this.additionaldata.permanentaddress == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Permanent Address" });
            return false;
        }
        if (this.additionaldata.permanentpin == null || this.additionaldata.permanentpin == '' || this.additionaldata.permanentpin.length < 6) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Permanent Pin" });
            return false;
        }

        if (this.additionaldata.permanentpin == null || this.additionaldata.permanentpin == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Permanent Pin" });
            return false;
        }
        if (this.additionaldata.permanentpin == null || this.additionaldata.permanentpin == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Enter Permanent Pin" });
            return false;
        }
        if (this.additionaldata.photo == null || this.additionaldata.photo == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload Applicant Picture" });
            return false;
        }

        if (this.additionaldata.sign == null || this.additionaldata.sign == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload Applicant Signature" });
            return false;
        }

        if (this.additionaldata.dateofbirthcertificate == null || this.additionaldata.dateofbirthcertificate == '') {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload Date of birth certificate" });
            return false;
        }

        if (this.additionaldata.categoryId != 1 && (this.additionaldata.castecertificate == null || this.additionaldata.castecertificate == '')) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload Caste certificate" });
            return false;
        }
        if (this.additionaldata.phid != 29 && (this.additionaldata.phcertificate == null || this.additionaldata.phcertificate == '')) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload Physically disabled certificate" });
            return false;
        }

        if (this.additionaldata.presentlyemployed === 'YES' && (this.additionaldata.currentemployercertificate == null || this.additionaldata.currentemployercertificate == '')) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: "Upload NOC from the present employer" });
            return false;
        }

        let acadata = [];
        this.acaDetailsInfo = [];
        let expdata = [];
        this.expDetailsInfo = [];
        acadata = this.additionaldata.academicData;

        for (let i = 0; i < acadata.length; i++) {
            if (acadata[i].marks > 100) {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Educational Qualification : % of Marks must not exceed 100 on row : ' + (i + 1) });
                return false;
            }

            if (acadata[i].edudetail != 0 && acadata[i].academicyr == 0) {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Educational Qualification : Please select Year of Passing on row : ' + (i + 1) });
                return false;
            }

            if (acadata[i].edudetail != 0 && (acadata[i].division == null || acadata[i].division == '')) {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Educational Qualification : Please enter Class / Division on row : ' + (i + 1) });
                return false;
            }
            if (acadata[i].exampass != 82 && acadata[i].exampass != 88 && acadata[i].exampass != 86 && acadata[i].exampass != 87) {
                if (acadata[i].edudetail != 0 && (acadata[i].marks == null || acadata[i].marks == '')) {
                    this.msgs = [];
                    this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Educational Qualification : Please select % of Marks on row : ' + (i + 1) });
                    return false;
                }
            }

            if (acadata[i].academicyr == '') {
                acadata[i].academicyr = 0;
            }
            if (acadata[i].edudetail == '') {
                acadata[i].edudetail = 0;
            }
            if (acadata[i].exampass == '') {
                acadata[i].exampass = 0;
            }
            if (acadata[i].marks == '') {
                acadata[i].marks = 0.0;
            }
            const newRow = {
                academicyr: acadata[i].academicyr,
                edudetail: acadata[i].edudetail,
                exampass: acadata[i].exampass,
                id: acadata[i].id,
                parent_id: acadata[i].parent_id,
                marks: acadata[i].marks,
                subjectstudied: acadata[i].subjectstudied,
                otherinfo: acadata[i].otherinfo,
                division: acadata[i].division,
                certificate: acadata[i].certificate,
                certificatename: acadata[i].certificatename
            };
            this.acaDetailsInfo.push(newRow);

        }
        this.additionaldata.academicData = this.acaDetailsInfo;

        for (let j = 2; j < acadata.length; j++) {
            if (acadata[j].edudetail != 0 && (acadata[j].certificate == null || acadata[j].certificate == '')) {
                this.msgs = [];
                this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Educational Qualification : Please Upload certificate on row : ' + (j + 1) });
                return false;
            }
        }

        expdata = this.additionaldata.experienceData;
        for (let i = 0; i < expdata.length; i++) {
            if (expdata[i].instituteName != undefined) {
                const newRow = {
                    id: expdata[i].id,
                    parent_id: expdata[i].parent_id,
                    instituteName: expdata[i].instituteName,
                    yearcount: expdata[i].yearcount,
                    typeofemployee: expdata[i].typeofemployee,
                    designation: expdata[i].designation,
                    payscale: expdata[i].payscale,
                    expcertificate: expdata[i].expcertificate,
                    remarks: expdata[i].remarks,
                };
                this.expDetailsInfo.push(newRow);
            }
        }
        this.additionaldata.experienceData = this.expDetailsInfo;

        const d = new Date(Date.parse(this.additionaldata.dob));
        this.additionaldata.dob = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();

        if (this.additionaldata.draftdate != null || this.additionaldata.draftdate != undefined) {
            const d1 = new Date(Date.parse(this.additionaldata.draftdate));
            this.additionaldata.draftdate = d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear();
        }
        if (this.additionaldata.phdthesissubmitdate != null || this.additionaldata.phdthesissubmitdate != undefined) {
            const d2 = new Date(Date.parse(this.additionaldata.phdthesissubmitdate));
            this.additionaldata.phdthesissubmitdate = d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear();
        }
        this.additionaldata.advid = this.advid;
        this.displayConfirmation = true;
        this.confirmmsg = "Do you want to submit?"
    }

    pay() {
        this.form.nativeElement.submit();
    }
    acceptsubmit() {
        this.displayConfirmation = false;
        this.processbar = true;
        console.log(this.additionaldata);
        this.registrationService.savestaffData(this.additionaldata).then(res => {
                // console.log(res);
                this.dataList = res;
                console.log(this.dataList.status);
                if (this.dataList.status == 'success') {
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.msg });
                    this.processbar = false;
                    this.showpdfdialog = true;
                    this.pdflink = this.dataList.admitsLink;
                    this.reset();
                }
                else if (this.dataList.status == 'success for payment') {
                    this.forpayment = true;
                    this.processbar = false;
                    this.paymentmsg = this.dataList.pymtmsg;
                    localStorage.setItem('onlinepayment', 'yes');
                    this.reset();
                    setTimeout(() => {
                        this.pay()
                    }, 2000);
                }
                else if (this.dataList.status == 'update') {
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.msg });
                    this.processbar = false;
                    localStorage.setItem('userdtls', JSON.stringify(this.dataList.dtls));
                    this.duplicatepdflink = this.dataList.admitsLink;
                    this.duplicatechallanlink = this.dataList.challanLink;
                    this.accept = false;
                    this.disablesubmit = false;
                }
                else if (this.dataList.status == 'exist') {
                    this.msgs = [];
                    this.msgs.push({ severity: 'error', summary: 'Error Message', detail: this.dataList.msg });
                    this.processbar = false;
                }
            }, error => {
                this.processbar = false;
            });
        }

    reject() {
            this.displayConfirmation = false;
        }

    acaAddRows() {
            const newRow = {
                academicyr: '0',
                edudetail: 0,
                exampass: 0,
                id: '',
                parent_id: '',
                marks: '',
                subjectstudied: '',
                otherinfo: '',
                division: '',
                certificate: '',
                certificatename: ''
            };
            this.additionaldata.academicData.push(newRow);
        }
    expAddRows() {
            const newRow = {
                id: '',
                parent_id: '',
                //fromdate: '',
                //todate: '',
                instituteName: '',
                yearcount: '',
                typeofemployee: '0',
                //monthcount: '',
                designation: '',
                //institutetype:'',
                payscale: '',
                expcertificate: '',
                remarks: '',
                //presentemployer:''
            };
            this.additionaldata.experienceData.push(newRow);
        }

    cloneRecForm(c: FormGroup): FormGroup {
            return c;
        }

    reset() {
            //this.getAllCommonList();
            this.additionaldata.id = null;
            this.additionaldata.name = null;
            this.additionaldata.email = null;
            this.additionaldata.dob = null;
            this.additionaldata.mobile = null;
            this.additionaldata.sex = null;
            this.additionaldata.address = null;
            this.additionaldata.distId = null;
            this.additionaldata.pin = null;
            this.additionaldata.designationId = null;
            this.additionaldata.departmentId = null;
            this.additionaldata.categoryId = null;
            this.additionaldata.phid = null;
            this.additionaldata.publjrnlno = null;
            this.additionaldata.publbooksno = null;
            this.additionaldata.publprocedingno = null;
            this.additionaldata.attndseminerno = null;
            this.additionaldata.attndconfno = null;
            this.additionaldata.attndworkshopno = null;
            this.additionaldata.phdguideno = null;
            this.additionaldata.researchprojno = null;
            this.additionaldata.apiscore = null;
            this.additionaldata.applicationNo = null;
            this.additionaldata.academicData = [];
            this.additionaldata.experienceData = [];
            this.additionaldata.userid = null;
            this.additionaldata.postcategoryid = null;
            this.additionaldata.draftdate = null;
            this.additionaldata.oldbankdeaftno = null;
            this.additionaldata.drwanbank = null;
            this.additionaldata.drwanamount = null;

            this.additionaldata.phdthesisname = null;
            this.additionaldata.phdthesissubmitdate = null;
            this.additionaldata.phduniversity = null;
            this.additionaldata.publpeerjrnlno = null;
            this.additionaldata.publjrnlugcno = null;
            this.additionaldata.attndnationalseminerno = null;
            this.additionaldata.attndinternationalseminerno = null;
            this.additionaldata.awardstate = null;
            this.additionaldata.awardinternational = null;
            this.additionaldata.disciplinary = null;
            this.additionaldata.disciplinarydtls = null;
            this.additionaldata.researchno = null;
            this.additionaldata.researcharea = null;
            this.additionaldata.researchplaces = null;
            this.additionaldata.mphilresearchguidence = null;
            this.additionaldata.phdilresearchguidence = null;
            this.additionaldata.noticeperiod = null;
            this.additionaldata.mailingaddress = null;
            this.additionaldata.mailingpin = null;
            this.additionaldata.mailingdistId = null;
            this.additionaldata.permanentaddress = null;
            this.additionaldata.permanentpin = null;
            this.additionaldata.permanentdistId = null;
            this.additionaldata.fathername = null;
            this.additionaldata.mothername = null;
            this.additionaldata.nationalityid = null;
            this.additionaldata.religionid = null;
            this.additionaldata.maritalstatus = null;
            this.additionaldata.password = null;
            this.additionaldata.totalexperience = null;
            this.additionaldata.presentlyemployed = null;
            this.additionaldata.photo = null;
            this.additionaldata.sign = null;
            this.additionaldata.dateofbirthcertificate = null;
            this.additionaldata.castecertificate = null;
            this.additionaldata.phcertificate = null;
            this.additionaldata.currentemployercertificate = null;
        }

    removeExp(index, id) {
            if(id == '') {
            this.additionaldata.experienceData.splice(index, 1);
        } else {
            this.registrationService.deleteExperienceByid(id).then(res => {
                this.additionaldata.experienceData.splice(index, 1);
                this.dataList = res;
            }, error => {
                this.processbar = false;
            });
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    myUploader(event, flg): void {
        this.processbar = true;
        if (event.files.length == 0) {

            return;
        }
        this.input = new FormData();
        var fileToUpload = event.files[0];
        this.input.append("file", fileToUpload);
        let expdata = [];
        expdata = this.additionaldata.experienceData;
        this.registrationService.docupload(this.input, flg).then(res => {
            this.dataList = res;

            if (this.dataList.status == 'success') {
                this.processbar = false;
                if (this.dataList.flg == 'dob') {
                    this.additionaldata.dateofbirthcertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'caste') {
                    this.additionaldata.castecertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'photo') {
                    this.additionaldata.photo = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'sign') {
                    this.additionaldata.sign = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'ph') {
                    this.additionaldata.phcertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'presentemployer') {
                    this.additionaldata.currentemployercertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
            }

        }, error => {
            this.processbar = false;
        })
    }

    onUpload(event): void {
        //console.log("onUpload");
        for (const file of event.files) {
            this.uploadedFiles.push(file);
        }

    }

    onBeforeSend(event): void {
        //console.log("onBeforeSend");
        //event.xhr.setRequestHeader('Authorization', 'Bearer ' + abp.auth.getToken());
    }

    handleAccept(e) {
        if (e) {
            this.disablesubmit = true;
            this.donotaccept = false
        } else {
            this.disablesubmit = false;
        }
    }

    handleDonotAccept(e) {
        if (e) {
            this.accept = false;
            this.disablesubmit = false;
        }
    }

    presentlemployer() {
        if (this.additionaldata.presentlyemployed === 'YES') {
            this.shownocCertificate = true;
        }
        else {
            this.shownocCertificate = false;
        }
    }

    setpermanentAddress(e) {
        if (e) {
            this.additionaldata.permanentaddress = this.additionaldata.mailingaddress;
            this.additionaldata.permanentpin = this.additionaldata.mailingpin;
        }
        else {
            this.additionaldata.permanentaddress = '';
            this.additionaldata.permanentpin = '';
        }
    }

    showCastecert() {
        //1,0
        if (this.additionaldata.categoryId == 1 || this.additionaldata.categoryId == 0) {
            this.showcastecertificate = false;
        }
        else {
            this.showcastecertificate = true;
        }
    }

    showPhcert() {
        //29,0
        if (this.additionaldata.phid == 29 || this.additionaldata.phid == 0) {
            this.showphcertificate = false;
        }
        else {
            this.showphcertificate = true;
        }
    }

    myUploaderAcademics(event, index) {
        let flg = index;
        this.processbar = true;
        if (event.files.length == 0) {
            console.log('No file selected.');
            return;
        }
        this.input = new FormData();
        var fileToUpload = event.files[0];
        // console.log(event.files[0].name+'+++');
        this.input.append("file", fileToUpload);

        let acadata = [];
        acadata = this.additionaldata.academicData;

        this.registrationService.docuploadacademics(this.input, flg).then(res => {
            this.dataList = res;

            if (this.dataList.status == 'success') {
                this.processbar = false;
                acadata[index].certificate = this.dataList.file;
                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
            }
        }, error => {
            this.processbar = false;
        })
    }

    openbankdetails() {
        if (this.previouslyapplied) {
            this.showbankdetails = true;
        }
        else {
            this.showbankdetails = false;
        }
    }

    password() {
        this.show = !this.show;
    }

    // add by jd start lpc upload
    lpcUploader(event, flg) {
        this.processbar = true;
        if (event.files.length == 0) {
            this.processbar = false;
            console.log('LPC : No file selected.');
            return
        } else {
            this.processbar = false;
            this.input = new FormData();
            var fileToUpload = event.files[0];
            this.input.append("file", fileToUpload);
            // console.log(event.files[0].name+event.files[0].size+' '+"File pushed to expDetails successfully ");
            let explpcdata = [];
            explpcdata = this.additionaldata.experienceData;

            this.registrationService.uploadlpc(this.input, flg).then(res => {
            this.dataList = res;
            // console.log(res);
            if (this.dataList.status == 'success') {
                this.processbar = false;
                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
            }, error => {
            this.processbar = false;
            })
            
        }
    }
    // end by jd end lpc upload
}



// WEBPACK FOOTER //
// ./src/app/staffrecruitmentonline/staffrecruitmentonline.component.ts